export default __webpack_public_path__ + "static/media/upmarket.534424a9.png";